import { BASE_API_URL } from '../apiConfig';

const VAPID_PUBLIC_KEY = 'BBo5X9mi5HcdJvn2nHvggwTVh0ak_1kauEdhJ3S0s3UBon4lhqmX16e6wwcUdTpMSqBLBNGpYLlmmkrTC2XdQlE';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const subscribeUserToPush = async () => {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      };
      subscription = await registration.pushManager.subscribe(subscribeOptions);
    }

    const token = localStorage.getItem('token');
    if (!token) return false;

    const res = await fetch(`${BASE_API_URL}/notifications/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ subscription: subscription.toJSON() })
    });

    return res.ok;
  } catch (error) {
    return false;
  }
};

export const unsubscribeUserFromPush = async () => {
    try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration) {
            const subscription = await registration.pushManager.getSubscription();
            if (subscription) {
                await subscription.unsubscribe();
            }
        }

        const token = localStorage.getItem('token');
        await fetch(`${BASE_API_URL}/notifications/unsubscribe`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });

        return true;
    } catch (error) {
        return false;
    }
};
